import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  ListGroup,
  Image,
  Form,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/hooks/useAuth";
import NavbarBackComp from "../../shared/components/NavbarBack";
import { useOrder } from "./hooks/useOrder";
import Swal from "sweetalert2";
import { usePromo } from "../promo/hooks/usePromo";
import { RxSlash } from "react-icons/rx";

const TransactionsPage = () => {
  const { alert, validatePromo, validatePromoState } = usePromo();
  const [loading, setLoading] = useState(false); // Add loading state

  const location = useLocation();
  const receivedData = location.state;

  const navigate = useNavigate();

  const { validate } = useAuth();

  const { postOrder, order } = useOrder();

  const [validatedPromo, setValidatedPromo] = useState(null);

  const [user, setUser] = useState();
  const [promoState, setPromoState] = useState({
    code_discount: "",
  });

  const [error, setError] = useState(null);

  const [orderedProducts] = useState(receivedData.cartItems);

  // Calculate the total price for the transaction
  const totalPrice = orderedProducts.reduce((acc, product) => {
    const price =
      product?.product?.promo_price != null
        ? Number(product.product.promo_price)
        : Number(product.product.starting_price);

    return acc + price * Number(product.qty);
  }, 0);

  // Function to simulate checkout process
  const handleCheckout = async () => {
    const DataObj = [];
    for (var i = 0; i < orderedProducts.length; i++) {
      var object = {
        product_id: orderedProducts[i].product.id,
        quantity: orderedProducts[i].qty,
      };
      DataObj.push(object);
    }
    const discount = validatedPromo?.code_promo
      ? validatedPromo?.code_promo
      : null;
    const bodyParameters = {
      code_discount: discount,
      // order_status: "",
      application_fee: "1200",
      payment_fee: "",
      updated_by: "",
      created_by: "",
      product_item: DataObj,
    };

    try {
      // Show a loading modal indicating that the transaction is in process.
      Swal.fire({
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await postOrder(bodyParameters);
      if (res) {
        // Update the modal to indicate success. The modal will auto-close after a timer.
        Swal.fire({
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        setTimeout(() => {
          window.location.href = res.xendit;
        }, 2000);
      }
    } catch (err) {
      setError("Transaction failed. Please try again.");
      // Show an error modal.
      Swal.fire({
        title: "Transaction Failed",
        text:
          error.message ||
          "An error occurred while processing your transaction.",
        icon: "error",
      });
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    (async () => {
      const userData = await validate();
      setUser(userData);
    })();
    // setCartItems(user?.cart)
  }, []);

  if (!receivedData.cartItems) {
    navigate("/cart");
  }

  const timeoutRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked, tagName } = e.target;

    setPromoState((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (value.trim()) {
      // Set new timeout
      setLoading(true); // Start loading
      timeoutRef.current = setTimeout(async () => {
        try {
          const result = await validatePromo({
            code_promo: value, // Use current value directly from event
          });

          if (!result) {
            setError("Promo code does not exist or has reached maximum usage.");
            setValidatedPromo(null);
          } else {
            setError(null);
            setValidatedPromo(result);
          }
        } catch (error) {
          setError("Error validating promo code");
          setValidatedPromo(null);
        } finally {
          setLoading(false); // Stop loading after API call
        }
      }, 3000);
    } else {
      // Clear validation if input is empty
      setError(null);
      setValidatedPromo(null);
    }
  };

  return (
    <Container
      fluid
      style={{
        backgroundColor: "#f0f0f0",
        backgroundPosition: "top right", // Position the image at the top-right corner
        backgroundSize: "auto", // Adjust the size of the background image
        height: "100vh", // Make the container take full height (optional)
      }}
    >
      <Container className="justify-content-center">
        <NavbarBackComp expand="lg" sticky="top" handleBack={handleBack} />

        <span
          style={{
            fontSize: 12,
            color: "gray",
          }}
        >
          RS YARSI
        </span>

        <p
          className="h6"
          style={{
            fontSize: 17,
            display: "flex",
            alignItems: "center",
            gap: "2px",
            padding: "0.1rem",
            paddingBottom: "0.5rem",
          }}
        >
          <span>
            Paket Layanan Kesehatan
            <RxSlash />
            Detail Pembayaran
          </span>
        </p>

        <Row className="pt-1">
          {/* Daftar Produk yang Dipesan */}
          <Col xs={12} sm={12} md={8}>
            <Card
              style={{
              //   borderTopLeftRadius: "2rem",
              //   borderTopRightRadius: "2rem",
                marginTop: "0.5rem",
                borderRadius: "1.5rem",
                background: "white",
                // height: "80vh",
              }}
              className="mb-0"
            >
              <Card.Body>
                <ListGroup variant="flush">
                  {orderedProducts.map((product) => (
                    <ListGroup.Item
                      key={product.id}
                      className="d-flex align-items-center"
                    >
                      <Image
                        src={
                          product.product.image
                            ? product.product.image
                            : "default_480x320.png"
                        }
                        alt={product.product.name}
                        width={50}
                        height={50}
                        rounded
                        className="me-3"
                      />
                      <div className="flex-grow-1">
                        <h5 className="mb-1">{product?.product?.name}</h5>
                        <small>
                          {product?.product?.promo_price ? (
                            <>
                              <del style={{ color: "gray" }}>
                                Rp. {product?.product?.starting_price}
                              </del>
                              &nbsp;
                              <span
                                style={{ color: "black", fontWeight: "bold" }}
                              >
                                Rp. {product?.product?.promo_price}
                              </span>
                            </>
                          ) : (
                            <span>Rp. {product?.product?.starting_price}</span>
                          )}{" "}
                          x {product?.qty} = Rp.
                          {product?.product?.promo_price != null
                            ? Number(product.product.promo_price) *
                              Number(product.qty)
                            : Number(product.product.starting_price) *
                              Number(product.qty)}
                        </small>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>

          {/* Ringkasan Transaksi */}
          <Col xs={12} sm={12} md={4}>
            <Card
              style={{
                borderTopLeftRadius: "0.5rem",
                borderTopRightRadius: "0.5rem",
                background: "white",
                // height: "30vh",
                marginTop: "0.5rem",
                marginBottom: "1.5rem"
              }}
            >
              {/* <Card.Header>
                <h4>Ringkasan Transaksi</h4>
              </Card.Header> */}
              <Card.Body>
                <p>
                  <strong>Total Harga:</strong> Rp {totalPrice}&nbsp;
                  {validatedPromo && (
                    <>
                      Diskon{" "}
                      <span className="text-success">
                        {validatedPromo.discount}%
                      </span>{" "}
                      | Harga Setelah Diskon: Rp{" "}
                      {totalPrice -
                        totalPrice * (validatedPromo.discount / 100)}
                    </>
                  )}
                </p>
                <Form.Group className="mb-2">
                  <Form.Label>Masukan code promo</Form.Label>
                  <Form.Control
                    type="text"
                    name="code_discount"
                    value={promoState.code_discount}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                {error && <p className="text-danger">{error}</p>}
                {validatedPromo && (
                  <p className="text-success">
                    Promo valid: {validatedPromo.name}
                  </p>
                )}
                <div className="d-grid">
                  <Button
                    variant="danger"
                    onClick={handleCheckout}
                    disabled={loading}
                    className="w-100"
                  >
                    {loading ? "Processing..." : "Lakukan Transaksi"}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default TransactionsPage;
